var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrivepd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 49,
    viewBox: "0 0 36 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 42.2123C7.04522 49.3765 18.248 49.1973 25.2665 42.0604C32.2848 34.9234 32.4158 23.5772 25.3706 16.4129L0 42.2123Z",
    fill: "#006EBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9999 5.87242L35.9063 5.77709C28.8603 -1.28524 17.5246 -1.25963 10.5251 5.85814C7.58158 8.8514 5.8627 12.5926 5.37549 16.4559H25.4048L35.9063 5.77709C35.9377 5.80861 35.9687 5.84062 35.9999 5.87242Z",
    fill: "#40C7A4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4048 16.4559L21.4836 20.4433L10.489 31.5818C6.3972 27.4208 4.69893 21.8205 5.37545 16.4559H25.4048Z",
    fill: "#00A0BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrivepd);
export default __webpack_public_path__ + "static/media/strivepd.e2c9c33f1241cb80cf7a398cb35e3cad.svg";
export { ForwardRef as ReactComponent };